import { cx } from '@linaria/core';
import 'react';
import { Select } from '@ui/kit';
import { componentEntryStore } from '../../state.js';
import { text, filtersWrapper, filter, modifiers, wrapper } from './filters.style.js';
import { useFilterValues } from './hook.filters.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { timespanOptions } from '../../utils/timespan.js';

function Filters(props) {
  const {
    showTimespanThrobber,
    filters,
    options
  } = useFilterValues();
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className),
    children: [/*#__PURE__*/jsx("p", {
      className: text,
      children: "Vis indhold fra:"
    }), /*#__PURE__*/jsxs("div", {
      className: filtersWrapper,
      children: [props.withTimespan && /*#__PURE__*/jsx("div", {
        className: cx(filter, showTimespanThrobber.current && modifiers.loading.className),
        children: /*#__PURE__*/jsx(Select, {
          label: "Periode",
          toggleValue: timespanId => componentEntryStore.dispatch(componentEntryStore.actions.filterByTimespan(timespanId)),
          selectedValues: [filters.timespan],
          options: timespanOptions,
          theme: "compact",
          collapseOnClick: true
        })
      }), props.withTeams && /*#__PURE__*/jsx("div", {
        className: filter,
        children: /*#__PURE__*/jsx(Select, {
          label: "Klasser",
          toggleValue: teamId => componentEntryStore.dispatch(componentEntryStore.actions.filterByTeam(teamId)),
          selectedValues: Object.keys(filters.teamIds),
          theme: "compact",
          multiSelect: true,
          options: options?.teams ?? []
        })
      }), props.withStudents && /*#__PURE__*/jsx("div", {
        className: filter,
        children: /*#__PURE__*/jsx(Select, {
          label: "Elever",
          toggleValue: studentId => componentEntryStore.dispatch(componentEntryStore.actions.filterByStudent(studentId)),
          selectedValues: Object.keys(filters.studentIds),
          theme: "compact",
          multiSelect: true,
          options: options?.students ?? []
        })
      }), props.withProducts && /*#__PURE__*/jsx("div", {
        className: filter,
        children: /*#__PURE__*/jsx(Select, {
          label: "L\xE6remidler",
          toggleValue: productId => componentEntryStore.dispatch(componentEntryStore.actions.filterByProduct(productId)),
          selectedValues: Object.keys(filters.productIds),
          theme: "compact",
          multiSelect: true,
          options: options?.products ?? []
        })
      })]
    })]
  });
}

export { Filters };
//# sourceMappingURL=filters.js.map
